module.exports = __webpack_public_path__ + "img/light_9.e5963fff.png";